import { render } from "./ControlloDogane.vue?vue&type=template&id=6a8a09ae&scoped=true"
import script from "./ControlloDogane.vue?vue&type=script&lang=js"
export * from "./ControlloDogane.vue?vue&type=script&lang=js"

import "./ControlloDogane.vue?vue&type=style&index=0&id=6a8a09ae&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8a09ae"]])

export default __exports__